//////////////////////////////////////////////
//! parallax();
//////////////////////////////////////////////
var parallax = {
	img:{
		path: 'img/plax-bkg/',
		layers: 6,
		land:[],
		port:[],
		loaded:{
			port: false,
			land:false,
		}
	},
	
	initPlax: function(){
		
		parallax.getImages();
		
	},
	
	getImages: function(){
		
		// Get the right set of images dependant on
		if(Detectizr.device.type =="mobile") {
		
			//Mobile Image
			parallax.img.port = ['mob-port_plax_clouds.jpg','mob-port_plax_0.png','mob-port_plax_1.png', 'mob-port_plax_2.png', 'mob-port_plax_3.png', 'mob-port_plax_4.png'];
			
			//parallax.img.land = ['desk-land_plax_clouds.jpg','mob-land_plax_0.gif','mob-land_plax_1.png', 'mob-land_plax_2.png', 'mob-land_plax_3.png', 'mob-land_plax_4.png'];
			
			parallax.img.loaded.land = true; //Landscape currently turned off so fake the load logging
			
			
		} else {
		
			parallax.img.port = ['desk-port_plax_clouds.jpg','desk-port_plax_0.png','desk-port_plax_1.png', 'desk-port_plax_2.png', 'desk-port_plax_3.png', 'desk-port_plax_4.png'];
			parallax.img.land = ['desk-land_plax_clouds.jpg','desk-land_plax_0.png','desk-land_plax_1.png', 'desk-land_plax_2.png', 'desk-land_plax_3.png', 'desk-land_plax_4.png'];
		
		}
		
		//For the number of layer load each image
		for (var i = 0; i < parallax.img.layers; i++) {
// 			console.log(parallax.img.port[i]);
			parallax.loadImg(parallax.img.path + parallax.img.port[i], 'port', parallax.insertImage,i);
			if(Detectizr.device.type != "mobile") {
				parallax.loadImg(parallax.img.path + parallax.img.land[i], 'land', parallax.insertImage,i);
			}
		}
		
	},
	
	//Load and image function
	loadImg:function(img, orient, callback, num){
		var image = new Image();
			image.src = img;
			image.onload = function(){
				callback(image,num, orient);
		};
	},
	
	//Insert iamge function
	insertImage:function(img,num,orient){
				
				//Distribute the images
				switch (num) {
					case 0:
						$('#js-parralax-bkg .'+orient).css('background-image','url('+img.src+')');
					break;
					case 1:
						$('#js-parralax-bkg .'+orient+' .parralax-bkg__l0').css('background-image','url('+img.src+')');
					break;
					case 2:
						$('#js-parralax-bkg .'+orient+' .parralax-bkg__l1').css('background-image','url('+img.src+')');
					break;
					case 3:
						$('#js-parralax-bkg .'+orient+' .parralax-bkg__l2').css('background-image','url('+img.src+')');
					break;
					case 4:
						$('#js-parralax-bkg .'+orient+' .parralax-bkg__l3').css('background-image','url('+img.src+')');
					break;
					case 5:
						$('#js-parralax-bkg .'+orient+' .parralax-bkg__l4').css('background-image','url('+img.src+')');
						
						//Log an orientation as loaded
						parallax.img.loaded[orient] = true;
						
						//Check Both orientations are loaded
						if (parallax.img.loaded.port && parallax.img.loaded.land) {
							//animate in when it's loaded
							$('#js-parralax-bkg').animate({
								'opacity': 1
							}, app.settings.pageSpeed);
							
							//Activate the parralax Effect
							parallax.addEvents();
							
						}
						
					break;
					default:
						// statements_def
					break;
				}
	},
	
/*
	moveClouds: function(){
		
		var vw = window.innerWidth;
		
		function getDuration(distance, pixelsPerSecond){
			var duration = distance / pixelsPerSecond;
			return duration;
		}
		
		TweenMax.fromTo( $(".parralax-bkg > div"), getDuration(vw, 7),{backgroundPositionX:'-200%', ease: Power0.easeNone},{backgroundPositionX:'230%',ease: Power0.easeNone, onComplete:parallax.moveClouds});
		
	},
*/
	
	ani:function(p1,p2){
		
		if(Detectizr.device.type =="desktop"){
				
				
				
			//Desktop
			TweenMax.to( $(".parralax-bkg__l0"),1,{x:0-(p1*20),y:0-(p2*5),scale: 1.1,overwrite:true});
			
			TweenMax.to( $(".parralax-bkg__l1"),1,{rotation:0-(p1*5), transformOrigin:"75% center", y:0+(p2*40),scale: 1.1,overwrite:true});
							
			TweenMax.to( $(".parralax-bkg__l3"),1,{rotation:0+(p1*10), transformOrigin:"75% center", y:0-(p2*40),scale: 1.1,overwrite:true});
			
			TweenMax.to( $(".parralax-bkg__l4"),1,{x:0+(p1*30),y:0+(p2*5),scale: 1.1,overwrite:true});
			
		} else {
		
			//Gyro Devices
			//IOS
			if(Detectizr.os.name =='ios') {
				//IPAD
				if(Detectizr.device.model =='ipad') {
					//PORTRAIT
					if(Detectizr.device.orientation == 'portrait') {
						
						TweenMax.to( $(".parralax-bkg__l0"),1,{x:0-(p1*40),y:-40-(p2*25),scale: 1.1,overwrite:true});
			
// 						TweenMax.to( $(".parralax-bkg__l1"),1,{y:-20+(p1*40),x:0+(p2*60),scale: 1.1,overwrite:true});
						TweenMax.to( $(".parralax-bkg__l1"),1,{rotation:0-(p1*5), transformOrigin:"center center", y:-10+(p2*20),scale: 1.1,overwrite:true});
							
// 						TweenMax.to( $(".parralax-bkg__l3"),1,{y:0-(p1*60),x:0-(p2*60),scale: 1.1,overwrite:true});
						TweenMax.to( $(".parralax-bkg__l3"),1,{rotation:0+(p1*20), transformOrigin:"center center", y:20+(p2*40),scale: 1.1,overwrite:true});
			
						TweenMax.to( $(".parralax-bkg__l4"),1,{x:0+(p1*50),y:0+(p2*25),scale: 1.1,overwrite:true});
						
					//LANDSCAPE
					} else {
						
						TweenMax.to( $(".parralax-bkg__l0"),1,{x:0-(p1*40),y:-20-(p2*25),scale: 1.1,overwrite:true});
			
// 						TweenMax.to( $(".parralax-bkg__l1"),1,{y:0+(p1*40),x:0+(p2*60),scale: 1.1,overwrite:true});
						TweenMax.to( $(".parralax-bkg__l1"),1,{rotation:0-(p1*5), transformOrigin:"75% center", y:-40+(p2*20),scale: 1.1,overwrite:true});
							
// 						TweenMax.to( $(".parralax-bkg__l3"),1,{y:0-(p1*60),x:0-(p2*60),scale: 1.1,overwrite:true});
						TweenMax.to( $(".parralax-bkg__l3"),1,{rotation:0+(p1*10), transformOrigin:"75% center", y:20-(p2*40),scale: 1.1,overwrite:true});
			
						TweenMax.to( $(".parralax-bkg__l4"),1,{x:0+(p1*50),y:0+(p2*25),scale: 1.1,overwrite:true});
						
					}
				//IPHONE
				} else {
					//PORTRAIT
					if(Detectizr.device.orientation == 'portrait') {
						TweenMax.to( $(".parralax-bkg__l0"),1,{x:0-(p1*30),y:0-(p2*15),scale: 1.1,overwrite:true});
			
// 						TweenMax.to( $(".parralax-bkg__l1"),1,{y:0+(p1*10),x:0+(p2*50),scale: 1.1,overwrite:true});
						TweenMax.to( $(".parralax-bkg__l1"),1,{rotation:0-(p1*10), transformOrigin:"center center", y:10+(p2*10),scale: 1.1,overwrite:true});
							
// 						TweenMax.to( $(".parralax-bkg__l3"),1,{y:0-(p1*40),x:0-(p2*50),scale: 1.1,overwrite:true});
						TweenMax.to( $(".parralax-bkg__l3"),1,{rotation:0+(p1*20), transformOrigin:"center center", y:-30-(p2*40),scale: 1.1,overwrite:true});
			
						TweenMax.to( $(".parralax-bkg__l4"),1,{x:0+(p1*20),y:0+(p2*25),scale: 1.1,overwrite:true});
					}
				}
			} else if (Detectizr.os.name =='android') {
				if(Detectizr.device.orientation == 'portrait') {
						TweenMax.to( $(".parralax-bkg__l0"),1,{x:0-(p1*30),y:0-(p2*15),scale: 1.1,overwrite:true});
			
						TweenMax.to( $(".parralax-bkg__l1"),1,{y:0+(p1*30),x:0+(p2*50),scale: 1.1,overwrite:true});
							
						TweenMax.to( $(".parralax-bkg__l3"),1,{y:0-(p1*50),x:0-(p2*50),scale: 1.1,overwrite:true});
			
						TweenMax.to( $(".parralax-bkg__l4"),1,{x:0+(p1*40),y:0+(p2*15),scale: 1.1,overwrite:true});
					}
				
			}
		}

	},
	
	addEvents:function(){
		
// 		parallax.moveClouds();
		
		if(Detectizr.device.type == "desktop"){
			
			//Desktop
			$( "#viewport" ).mousemove(function( event ) {
				var p1 = -1*((event.clientX/ $(this).width()) -0.5);
				var p2 = -1*((event.clientY/ $(this).height()) -0.5);
				parallax.ani(p1,p2);
			});
		
			
			
			
		} else {
// 			alert();
			
			var devicePercentX = 0;
			var devicePercentY = 0;
		
			
			//Mobile
			window.addEventListener("devicemotion",function( event ) {
				var accelerationX = event.accelerationIncludingGravity.x;
				var accelerationY = event.accelerationIncludingGravity.y;
				devicePercentX = (accelerationY  * 0.1) + (devicePercentX * (1.0 - 0.1))/10.5;
				devicePercentY = (accelerationX  * 0.1) + (devicePercentY* (1.0 - 0.1))/-10.5;
				
				if(Detectizr.device.orientation == 'portrait') {
					parallax.ani(devicePercentY,devicePercentX);
				} else {
					parallax.ani(devicePercentX,devicePercentY);
				}
				
			});
		}
	},
	
	removeEvents:function(){
		if(Detectizr.device.type =="desktop"){
			
			//Desktop
			$( "#viewport" ).unbind("mousemove");
		
		} else {
			
			//Mobile
			window.removeEventListener("devicemotion",null);
		}
	}
	
	
};